/**
 * Grades Store
 * Manages grades data for filters
 * Separated from monolithic store following SOLID principles
 */

import { create } from 'zustand';
import { fetchGrades } from '../services/grades.service';
import { globalConfig } from '../config/globalConfig';
import type { GradesStore } from '../interfaces/storeInterfaces/gradesStore';

export const useGradesStore = create<GradesStore>((set, get) => ({
  // Initial State
  grades: [],
  allGrades: [],
  isLoading: false,
  error: null,

  // Actions
  load: async () => {
    set({ isLoading: true, error: null });
    try {
      const response = await fetchGrades({ page_size: globalConfig.defaultPageSize });
      set({ grades: response.data, allGrades: response.data, isLoading: false });
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Failed to load grades';
      set({ error: message, isLoading: false });
      console.error('Failed to load grades:', error);
    }
  },

  filterByCountry: (countryIsoCode: string | null) => {
    const { allGrades } = get();
    if (!countryIsoCode) {
      set({ grades: allGrades });
    } else {
      const filtered = allGrades.filter(
        (grade) => grade.country_iso_code.toLowerCase() === countryIsoCode.toLowerCase()
      );
      set({ grades: filtered });
    }
  },

  reset: () => set({ grades: [], allGrades: [], isLoading: false, error: null }),
}));
